import { render, staticRenderFns } from "./DetailItemAFA.vue?vue&type=template&id=503d0c17&"
import script from "./DetailItemAFA.vue?vue&type=script&lang=js&"
export * from "./DetailItemAFA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports